import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { useAdminDetailDataQuery } from "api/auth/auth.mutation";
import hamburgerMenuIcon from "assets/admin/hamburgerMenu.svg";
import logo from "assets/admin/logo.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { DashboardRoutes } from "routes/DashboardRoutes";
import useStore from "store";
import MenuItem from "./MenuItem";
import classes from "./style.module.scss";

const Sidebar = () => {
  const { storeSetSidebarOpening, sidebarOpenStore, userInfoStore } = useStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const adminDetailQuery = useAdminDetailDataQuery();
  const myReferralBadge = adminDetailQuery.data?.referral_count ?? 0;

  return (
    <Drawer
      anchor="right"
      variant={isMobile ? "temporary" : "persistent"}
      open={sidebarOpenStore}
      onClose={() => storeSetSidebarOpening(false)}
      ModalProps={{
        keepMounted: true,
      }}
      className={classes.drawer}
    >
      {isMobile && (
        <IconButton className={classes.mobileHamburgerIcon}>
          <LazyLoadImage
            onClick={() => storeSetSidebarOpening(!sidebarOpenStore)}
            src={hamburgerMenuIcon}
            style={{ width: "1.8rem" }}
          />
        </IconButton>
      )}

      <div className={classes.sidebar}>
        <Box className={classes.mainImage}>
          <LazyLoadImage src={logo} className={classes.logo} />
        </Box>

        <ul className={classes.listMenu}>
          {DashboardRoutes.map((route, index) => {
            if (route.in_sidebar) {
              const itemElement = (
                <MenuItem
                  key={index}
                  title={route.title}
                  to={route.path}
                  icon={route.icon}
                  badgeValue={route.title === "پرونده های من" ? myReferralBadge : 0}
                />
              );
              if (route?.superuser) {
                if (userInfoStore?.is_superuser) {
                  return itemElement;
                }
              } else {
                return itemElement;
              }
            }
          })}
        </ul>
      </div>
    </Drawer>
  );
};

export default Sidebar;
